import { APP_BASE_HREF } from '@angular/common';
import { inject, InjectionToken, type Provider } from '@angular/core';
import { type WidgetConfig } from './widget-config.interface';

const WIDGET_CONFIG = new InjectionToken<WidgetConfig>('WIDGET_CONFIG');

export function provideWidgetConfig(config: WidgetConfig): Provider[] {
    return [
        // This will tell Angular to add the app url to asset requests
        { provide: APP_BASE_HREF, useValue: config.appUrl },
        { provide: WIDGET_CONFIG, useValue: config }
    ];
}

export function injectWidgetConfig(): WidgetConfig {
    return inject(WIDGET_CONFIG);
}

export function injectWidgetConfigProp<PropName extends keyof WidgetConfig>(propertyName: PropName): WidgetConfig[PropName] {
    return injectWidgetConfig()[propertyName];
}

export function injectPromptContextComposer(): () => string {
    // #region TEMPORARY CONTEXT HACK
    // The current implementation on the server simply concatenates the string
    // with the prompt, which hurts the responses.
    //
    // The default behavior for now will be to send an empty string as context.
    // Developers can force usage of the real context function by providng the `&context`
    // query param.
    //
    // TODO: Once TensorOps improve their context handling on the server, remove this hack
    //       so that the context function will always be used.
    if (!new URLSearchParams(location.search).has('context')) return () => '';
    // #endregion

    const contextComposeFnName = injectWidgetConfigProp('contextComposeFnName');

    if (!contextComposeFnName) return () => '';

    const composeContext = (window as any)[contextComposeFnName];

    return composeContext ?? (() => '');
}
